import { render } from "./8.CaseStudySection.vue?vue&type=template&id=564cdfaa&scoped=true"
import script from "./8.CaseStudySection.vue?vue&type=script&lang=js"
export * from "./8.CaseStudySection.vue?vue&type=script&lang=js"

import "./8.CaseStudySection.vue?vue&type=style&index=0&id=564cdfaa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-564cdfaa"]])

export default __exports__